import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { CartonModel, CartonCodesModel } from '../models/carton';

@Injectable({
  providedIn: 'root'
})
export class CartonProvider {

  cartonList: CartonModel[] = [];
  cartonCodes: CartonCodesModel[] = [];
  cartonId;
  constructor(
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  getCartonsList(): void {
    if (this.cartonList.length == 0) {
      this.apiService.get(this.apiConfig.getCartonList).subscribe(
        (res: any) => {
          this.cartonList = res.data.carton_details as CartonModel[];
        },err=>{
          this.toast.Error(err.body.data.message);
        }
      );
    }
  }



//   addCampaign(formdata): void {
//     this.apiService.post(this.apiConfig.addCampaign, formdata)
//         .subscribe((res: any) => {
//             console.log(res);
//             this.campaigns.push(formdata);
//             this.toast.Success(res.body.data.message)
//         }, err => {
//             console.log(err);
//         })
// }


}